// extracted by mini-css-extract-plugin
module.exports = {"mobileQAHolder":"MobileQA_mobileQAHolder__2f4he"};